/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Base = function () {

    this.rootEl = null;
    this.label = null;
    this.isMandatory = false;
    this.isHidden = false;
    this.disabled = false;
    this.maxSize = null;
    this.value = "";
    this.defaultValue = null;
    this.name = null;
    this.meta = null;
    this.entity = null;

    var __options = null;

    this.createRootElement = function () {

        this.rootEl = document.createElement('div');
    };

    this.createLabel = function () {

        this.label = document.createElement('label');

    };

    this.createBaseStructure = function () {

        this.createRootElement();
        this.createLabel();
        this.rootEl.appendChild(this.label);

    };

    this.hide = function () {
        this.clear();
        this.isHidden = true;
        this.rootEl.style.display = "none";
    };

    this.show = function () {
        this.isHidden = false;
        this.rootEl.style.display = "block";
    };

    this.formatFieldToJson = function(value){
        if(this.meta){

            var fields = this.meta.fieldPath.split('.');
            var fieldValue = value;

            for(var x = fields.length - 1; x >= 0; x--){

                var obj = {};
                obj[fields[x]] = fieldValue;
                fieldValue = obj;

            }

            return fieldValue;

        }

        return {id: value};
    };

    this.getValueFromJsonElement = function(value){
        var fieldValue = value;

        if(this.meta){
            var fields = this.meta.fieldPath.split('.');

            for(var x = 0, size = fields.length; x < size -1; x++){
                fieldValue = fieldValue[fields[x]];

            }

        }

        return fieldValue;
    };

    this.setId = function (id) {

        if (this.rootEl && id) {
            this.rootEl.id = id;
        }

    };

    this.getId = function () {
        return (this.rootEl.id || this.input.name);
    };

    this.setMandatory = function (isMandatory){
        this.mandatory = isMandatory;
    };

    this.isMandatory = function (){
       return this.mandatory;
    };

    this.setDefaultValue = function (defaultValue){
        this.defaultValue = defaultValue;
        if(this.defaultValue && this.input){
            this.input.value = this.defaultValue;
        }
    };

    this.getDefaultValue = function () {
       return this.defaultValue;
    };

    this.clear = function (){
        this.value = '';
        if(this.input){
            this.input.value = '';
        }
    };

    this.setTextLabel = function (content) {

        if (this.label && content) {
            this.label.textContent = content;
        }

    };

    this.setInputName = function (name) {
        this.name = name;

        if (this.input && name) {
            this.input.name = name;
        }

    };

    this.setClassName = function ( className ) {
        if ( this.input ) {
            this.input.className = className;
        }
    };

    this.setInputId = function (id) {

        if (this.input && id) {
            this.input.id = id;
        }

    };

    /**
     * Seta as meta informações do field.
     * Pode ser passado como string,
     * a função faz o parse para um Objeto se necessário.
     * @param options
     */

    this.setOptions = function (options) {

        if(options) {

            if (typeof options === "string") {
                options = JSON.parse(options);
            }
            __options = options;
        }

    };

    this.getOptions = function () {
        return __options;
    };

    this.setValue = function (value) {
        this.value = value;
        if(this.input){
            this.input.value = this.value;
        }
    };

    this.getValue = function () {
        if(this.input){
            this.value = this.input.value;
        }
        return this.value;
    };

    this.isEmpty = function () {
        const value = this.getValue();
        
        if(value instanceof Array){
            return (value.length === 0);
        } else {
            const parsedValueLength = String(value).trim().length;

            return parsedValueLength === 0 || !(value || value === 0);
        }
    };

    this.dataIsInvalid = function () {
        return false;
    };

    this.dataInvalidErrorText = "field.isInvalid";

    this.getErrorMessage = function (isMandatoryAndIsNotFilledAndIsNotHidden, dataIsInvalid) {
      var errors = [];
      var fieldLabel = this.label.textContent;

      if (isMandatoryAndIsNotFilledAndIsNotHidden) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey('general.mandatoryField', Monet.I18n.getResourcesByKey(fieldLabel))));
      }

      if (dataIsInvalid) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey(fieldLabel) + " " + Monet.I18n.getResourcesByKey(this.dataInvalidErrorText)));
      }

      if(isMandatoryAndIsNotFilledAndIsNotHidden || dataIsInvalid){
        this.rootEl.className += ' control-group error';
      }

      return errors;
    }

    this.validate = function () {
      return this.getErrorMessage((this.isMandatory() && this.isEmpty() && !this.isHidden), this.dataIsInvalid())
    };

    this.getFilterValue = function (){
        return this.getValue();
    };

    this.getFullValue = function (){
        return this.getValue();
    };

    this.getMaxSize = function (){
      return this.maxSize;
    };

    this.setMaxSize = function (maxSize){
        this.maxSize = maxSize;
    };

    this.enable = function (){
        if(this.input){
            this.input.disabled = false;
        }
    };

    this.disable = function (){
        if(this.input){
            this.input.disabled = true;
        }
    };

    this.toggleDisabled = function (){
        if(this.input){
            this.input.disabled = !this.input.disabled;
        }
    };

    this.setMeta = function (meta) {
        if(meta && typeof meta === 'string'){
            meta = JSON.parse(meta);
        }
        this.meta = meta;
    };

    this.getMeta = function () {
      return this.meta;
    };

    this.setEntity = function (entity) {
        if(entity){
            this.entity = entity;
        }
    };

    this.getEntity = function () {
      return this.entity;
    };

    this.render = function () {
        
        this.createBaseStructure();
        return this.rootEl;

    };

    /**
     * Needed for date/time range fields for focusing on the next field when done with the first one
     * @param dpCloseSelector {String} selector for the element responsible for closing datepicker on the first input field
     * @param dpInst {Object} datepicker instance
     */
    this.focusNext = (dpCloseSelector, dpInst) => {
        // using setTimeout(fn, 0) postpones fn execution so it does not conflict with datepicker events
        setTimeout(() => {
            if (dpInst.dpDiv) {
                dpInst.dpDiv.find(dpCloseSelector).off('click');
                dpInst.dpDiv.find(dpCloseSelector).on('click', (e) => {
                    const isFilterBuilder = this.inputIni.parentNode.classList.contains('MonetUIFilterBuilderFilterEl');
                    setTimeout(() => {
                        if (isFilterBuilder && this.inputIni.value && (!this.inputFin.value || this.inputFin.value === '00:00:00')) {
                            this.inputFin.focus();
                        } else {
                            dpInst.dpDiv.hide();
                        }
                    }, 0);
                });
            }
        }, 0);
    };
};
